import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { IOAuthCredential } from '~src/connectivity/serverApi/types/OAuth/IOAuthCredential';
import { getSessionManagementServiceInstance, SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { ActivityLogSettings } from '~src/settings/IntegrationsSettings/activityLog/ActivityLogSettings';
import { AuthFederationSection } from '~src/settings/IntegrationsSettings/authFederation/AuthFederationSection';
import { MsTeamsIntegrationSettings } from '~src/settings/IntegrationsSettings/msTeamsConnectivity/MsTeamsIntegrationSettings';
import { SlackIntegrationSettings } from '~src/settings/IntegrationsSettings/slackConnectivity/SlackIntegrationSettings';
import {
  integrationSettingsContainer,
  integrationSpaceContainer
} from '~src/settings/IntegrationsSettings/styles/IntegrationsSettingsStyles';
import { Sites } from '~src/siteManagement/services/resources/Sites';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ServerSettingsSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';
import { SiteRoles } from '~src/userManagement/users/serverApi/types/ISiteRole';

import ExploreInTableauServerSection from './exploreInTableau/server/ExploreInTableauServerSection';
import { PublishSalesforceBundlesSettings } from './PublishSalesforceBundlesSettings';
import { PublishToSalesforceSettings } from './PublishToSalesforceSettings';

export const IntegrationsSubspaceName: ServerSettingsSubspaceName = 'integrations';

export interface IntegrationsSettingsSubspaceOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
  readonly server: SessionManagementService;
  readonly isSessionServerAdmin: boolean;
  readonly isOnlineEnvironment: boolean;
  readonly userRole: String;
  readonly sites: Sites;
  readonly isSingleSiteServerWithIntegrations: boolean;
  readonly isSiteSettings: boolean;
}

export type IntegrationsSettingsSubspaceProps = IntegrationsSettingsSubspaceOwnProps;

export interface IntegrationsSettingsSubspaceState {
  readonly credentials: IOAuthCredential[];
}

export class IntegrationsSettingsSubspaceComponent extends React.PureComponent<IntegrationsSettingsSubspaceProps, IntegrationsSettingsSubspaceState> {

  public constructor(props: IntegrationsSettingsSubspaceProps) {
    super(props);
    this.state = {
      credentials: null,
    };
  }

  public async componentDidMount() {
  }

  public render(): JSX.Element {
    return (
      <div className={integrationSpaceContainer}>
        {(this.props.isSiteSettings || this.props.isSingleSiteServerWithIntegrations) && (
          <>
            {this.shouldRenderSalesforceIntegrationSettings() && <div className={integrationSettingsContainer}>
              <PublishSalesforceBundlesSettings
                server={this.props.server}
                isOnlineEnvironment={this.props.isOnlineEnvironment}
                urls={this.props.urls}
              />
            </div>}
            {this.shouldRenderPublishToSalesforceSettings() && <div className={integrationSettingsContainer}>
              <PublishToSalesforceSettings server={this.props.server} sites={this.props.sites} />
            </div>}
            {this.shouldRenderSlackSettings() && <div className={integrationSettingsContainer}>
              <SlackIntegrationSettings />
            </div>}
            {this.shouldRenderMsTeamsSettings() && <div className={integrationSettingsContainer}>
              <MsTeamsIntegrationSettings />
            </div>}
            {<div className={integrationSettingsContainer}>
              <ActivityLogSettings />
            </div>}
            {<div style={{ marginLeft: '85px', paddingBottom: '8px', maxWidth: '900px' }}>
              <AuthFederationSection />
            </div>}
        </>
        )}
        {!this.props.isSiteSettings && <div className={integrationSettingsContainer}>
          <ExploreInTableauServerSection/>
        </div>}
      </div>
    );
  }

  private shouldRenderSalesforceIntegrationSettings = (): boolean => {
    const isUserAuthorized: boolean = this.props.userRole === SiteRoles.ServerAdministrator || this.props.userRole === SiteRoles.SiteAdministratorCreator;
    return isUserAuthorized && this.props.isOnlineEnvironment;
  };

  private shouldRenderPublishToSalesforceSettings = (): boolean => {
    const isUserAuthorized: boolean = this.props.userRole === SiteRoles.ServerAdministrator || this.props.userRole === SiteRoles.SiteAdministratorExplorer || this.props.userRole === SiteRoles.SiteAdministratorCreator;
    return isUserAuthorized;
  };

  private shouldRenderSlackSettings = (): boolean => {
    return getSessionManagementServiceInstance().isUserNotificationsPlatformEnabled() && FeatureFlags.userNotificationSlackChannel;
  };

  private shouldRenderMsTeamsSettings = (): boolean => {
    return getSessionManagementServiceInstance().isUserNotificationsPlatformEnabled() && FeatureFlags.msTeamsUserNotification;
  };

}
